import React from 'react';
import PropTypes from 'prop-types';

const Cache = React.memo(
  ({ children }) => {
    return children;
  },
  (prevProps, nextProps) => {
    // shouldComponentUpdate({ disabled = false }) { return disabled; }
    // Invert logic: rerender only if disabled is true
    return !nextProps.disabled;
  },
);

Cache.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

Cache.defaultProps = {
  disabled: false,
  children: null,
};

export { Cache };
